
import React, { useState } from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import HtmlEditor from "@/components/admin/HtmlEditor";
import PostContent from "@/components/blog/PostContent";

interface PostEditorContentProps {
  content: string;
  setContent: (content: string) => void;
  theme: string;
  featuredImage: string;
  featuredImageAlt: string;
  featuredImageTitle: string;
  title: string;
  postId?: string;
}

const PostEditorContent: React.FC<PostEditorContentProps> = ({
  content,
  setContent,
  theme,
  postId,
  featuredImage,
  featuredImageAlt,
  featuredImageTitle,
  title
}) => {
  const [activeTab, setActiveTab] = useState<"edit" | "preview">("edit");
  
  const handleNoopSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };

  return (
    <Card className="shadow-sm">
      <CardHeader className="border-b">
        <CardTitle className="flex justify-between items-center">
          <span>Content Editor</span>
          <div className="flex space-x-2">
            <Button
              type="button"
              variant={activeTab === "edit" ? "default" : "outline"}
              onClick={() => setActiveTab("edit")}
              size="sm"
            >
              Edit
            </Button>
            <Button
              type="button"
              variant={activeTab === "preview" ? "default" : "outline"}
              onClick={() => setActiveTab("preview")}
              size="sm"
            >
              Preview
            </Button>
          </div>
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0 h-[80vh]">
        {activeTab === "edit" ? (
          <HtmlEditor
            value={content}
            onChange={setContent}
            fullHeight={true}
            className="border-0 shadow-none"
            theme={theme}
            postId={postId}
          />
        ) : (
          <div className="p-0 max-h-[80vh] min-h-[700px] overflow-auto">
            {featuredImage && (
              <div className="w-full relative">
                <img 
                  src={featuredImage}
                  alt={featuredImageAlt || title || "Featured image"}
                  title={featuredImageTitle || ""}
                  className="w-full h-64 object-cover"
                />
                {title && (
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                    <h1 className="text-white text-3xl font-bold">{title}</h1>
                  </div>
                )}
              </div>
            )}
            <div className="p-6">
              <PostContent content={content} theme={theme} />
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default PostEditorContent;
